import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext.jsx";
import DashboardLayout from "./components/DashboardLayout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Campaigns from "./pages/Campaigns";
import Badges from "./pages/Badges";
import Features from "./pages/Features";
import UserQueries from "./pages/UserQueries.jsx";
import SlayDetails from "./pages/SlayDetails";
import CampaignDetails from "./pages/CampaignDetails";
import UserManagement from "./pages/UserManagement.jsx";
import Transactions from "./pages/Transactions.jsx";
import ReportsManagement from "./pages/ReportsManagement.jsx";
import StickersManagement from "./pages/StickersManagement.jsx";
import MusicManagement from "./pages/MusicManagement.jsx";
import CryptoManagement from "./pages/CryptoManagement.jsx";
import CouponsManagement from "./pages/CouponsManagement.jsx";
import ChatbotManagement from "./pages/ChatbotManagement.jsx"; // Added Import

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/features" element={<Features />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/user-queries" element={<UserQueries />} />
            <Route path="/reports" element={<ReportsManagement />} />
            <Route path="/slay-details/:userId" element={<SlayDetails />} />
            <Route path="/campaign/:campaignId" element={<CampaignDetails />} />
            <Route path="/stickers" element={<StickersManagement />} />
            <Route path="/music" element={<MusicManagement />} />
            <Route path="/crypto" element={<CryptoManagement />} />
            <Route path="/coupon" element={<CouponsManagement />} />
            <Route path="/chatbot" element={<ChatbotManagement />} /> {/* Added Route */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
